// extracted by mini-css-extract-plugin
export default {"registerForm":"register_registerForm__Eys6W","link":"register_link__nI05d"};